import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { AuthLayout } from "./layout/AuthLayout";
const LoginForm = lazy(() => import("./Login/loginForm"));
const ForgotPassword = lazy(() => import("./ForgotPassword/ForgotPassword"));
import moduleRoutes from "../routes/moduleRouteList";
import Loader from "../utilis/component/SkeletonLoading/Loader";
import PageRouterList from "@routes/routeList";

const authenticationRoute:RouteObject = {
  path: moduleRoutes.authentication,
  element: <AuthLayout />,
  children: [
    {
      index:true,
      element: (
         <Loader>
           <LoginForm />
         </Loader>
      ),
    },
    {
      path: PageRouterList.forgotPassword,
      element: (
          <Loader>
            <ForgotPassword />
          </Loader>
      ),
    },
  ],
}

export default authenticationRoute;
